const fontFamily = 'NunitoSans-Regular';

export default {
    regular: {
        fontFamily: fontFamily,
        fontWeight: 'normal'
    },
    bold: {
        fontFamily: 'NunitoSans-Bold'
    }
};
